// extracted by mini-css-extract-plugin
module.exports = {"headerGroup":"TrainListHeaderGroup_headerGroup_45w4l"};